export const infoConfig = {
	name: "Palma Njivice",
	guests: 2,
	extraGuests: 2,
	stars: 3,
	coords: [45.15478541425649, 14.535195939617495],
	googleMapsLink: 'https://maps.app.goo.gl/XAgh45FBYbTSa8gr6',
	address: 'Luke Turata 29, Njivice, Croatia',
	wappLink: 'https://wa.me/38598419904',
	phone: '+385 98 419 904',
	email: 'vidas.kris18@gmail.com',
	authKey: 'c71bc57d-710f-4cd6-9d60-870d3ef5a2a4',
};

export const discoverLinks = [
	{
		name: 'welcomePage.islandKrk',
		link: 'https://krk.hr/',
	},
	{
		name: 'welcomePage.baska',
		link: 'https://www.visitbaska.hr/',
	},
	{
		name: 'welcomePage.rijeka',
		link: 'https://visitrijeka.hr/',
	},
	{
		name: 'welcomePage.opatija',
		link: 'https://www.visitopatija.com/en',
	},
	{
		name: 'welcomePage.istria',
		link: 'https://www.istra.hr/hr',
	},
];

import { markRaw } from "vue";
import ParkingIcon from "@/components/icons/ParkingIcon.vue";
import WifiIcon from "@/components/icons/WifiIcon.vue";
import BeachIcon from "@/components/icons/BeachIcon.vue";
import BalconyIcon from "@/components/icons/BalconyIcon.vue";
import ACIcon from "@/components/icons/ACIcon.vue";
import WasherIcon from "@/components/icons/WasherIcon.vue";
import MicrowaveIcon from "@/components/icons/MicrowaveIcon.vue";
import CoffeeIcon from "@/components/icons/CoffeeIcon.vue";
import TvIcon from "@/components/icons/TvIcon.vue";

export const services = [
	{
		name: 'services.beach',
		icon: markRaw(BeachIcon),
	},
	{
		name: 'services.parking',
		icon: markRaw(ParkingIcon),
	},
	{
		name: 'services.terrace',
		icon: markRaw(BalconyIcon),
	},
	{
		name: 'services.freeWifi',
		icon: markRaw(WifiIcon),
	},
	{
		name: 'services.ac',
		icon: markRaw(ACIcon),
	},
	{
		name: 'services.laundryWasher',
		icon: markRaw(WasherIcon),
	},
	{
		name: 'services.dishWasher',
		icon: markRaw(WasherIcon),
	},
	{
		name: 'services.microwave',
		icon: markRaw(MicrowaveIcon),
	},
	{
		name: 'services.coffeeMachine',
		icon: markRaw(CoffeeIcon),
	},
	{
		name: 'services.tv',
		icon: markRaw(TvIcon),
	},
];
